export const TOTAL_ROWS_COUNT_CLASS_NAME = 'kurama-total-rows-count'
